import httpService from "./httpService";

export default {
  create(form) {
    return httpService.post("/hcCaseCommandsCommon", form);
  },

  update(id, form) {
    return httpService.put(`/hcCaseCommandsCommon/${id}`, form);
  },

  findById(id) {
    return httpService.get(`/hcCaseCommandsCommon/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/hcCaseCommandsCommonService.js